import React from 'react';
import ReactDOM from 'react-dom';
import { parseLocation } from 'react-hawksearch';
import SearchBoxPreview from 'components/preview-autocomplete/SearchBoxPreview';
import CustomSuggestionListPreview from 'components/preview-autocomplete/CustomSuggestionListPreview';

window.addEventListener('load', () => {
	const component = document.getElementById('react-app-autocomplete');
	if (component) {
		const baseAPI = component.getAttribute('data-base-api');
		const apiUrlObj = {
			searchApi: component.getAttribute('data-search-api'),
			autocompleteApi: component.getAttribute('data-autocomplete-api'),
		};

		if (!baseAPI || !apiUrlObj) {
			return false;
		}

		const hawkConfig = {
			clientGuid: component.getAttribute('data-client-guid'),
			baseAPI,
			searchPageUrl: component.getAttribute('data-search-page'),
			indexName: component.getAttribute('data-index-name'),
			trackEventUrl: component.getAttribute('data-tracking-api'),
			...apiUrlObj,
		};

		function SearcBox() {
			const searchRequest = parseLocation(location);
			return (
				<>
					<SearchBoxPreview SuggestionList={CustomSuggestionListPreview} />
				</>
			);
		}
		ReactDOM.render(<SearcBox />, component);
	}
	return;
});
